import React from 'react'
// import AboutHeader from '../../components/user/About/AboutHeader';
import AboutNgo from "../../components/user/About/AboutNgo";
import AboutHistory from '../../components/user/About/AboutHistory';
import AboutOurPhilosophy from '../../components/user/About/AboutOurPhilosophy';
import AboutCollaborateCampaign from '../../components/user/About/AboutCollaborate';
import AboutOurApproach from '../../components/user/About/AboutOurApproach';
import AboutInpactSts from "../../components/user/About/AboutInpactSts";
import NavigationBanner from '../../components/common/NavigationBanner';
import HeaderImg from "../../Assets/Images/about/About-bg.png";
import OurValues from '../../components/user/About/OurValues';


const About = () => {
  return (
    <div className='overflow-x-hidden'>
      {/* <AboutHeader /> */}
      <NavigationBanner title={"About us"} background={HeaderImg} />
      <AboutNgo />
      <AboutHistory />
      <AboutOurPhilosophy />
      <AboutInpactSts />
      <AboutOurApproach />
      <AboutCollaborateCampaign />
      <OurValues/>
    </div>
  );
}

export default About;
